export default __webpack_public_path__ + "static/media/configure2.9c72c6aa.svg";